module.exports = __webpack_public_path__ + "img/card_250460827.49048ed2.jpg";